import { Component, Inject, OnInit } from '@angular/core';
import { MAT_SNACK_BAR_DATA, MatSnackBar } from '@angular/material';

@Component({
  selector: 'bil-snackbar',
  templateUrl: './bil-snackbar.component.html'
})
export class BilSnackbarComponent implements OnInit {
  constructor(
    @Inject(MAT_SNACK_BAR_DATA) public data: any,
    private snackbar: MatSnackBar
  ) {}

  ngOnInit() {}

  public closeSnackBar() {
    this.snackbar.dismiss();
  }
}
